import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

/**
 * Service that manages communication from/to wizards
 */
@Injectable({ providedIn: 'root' })
export class WizardCommunicationService {
    private closeUploadWizard$ = new Subject<void>();
    private closeUploadWizardObservable$ = this.closeUploadWizard$.asObservable();

    /**
     * Sends an event when the upload wizard has been closed
     */
    uploadWizardClose(): void {
        this.closeUploadWizard$.next();
    }

    /**
     * Checks when the upload wizard has been closed
     */
    onUploadWizardClose(): Observable<void> {
        return this.closeUploadWizardObservable$;
    }
}
